// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media print {\n.tabs > div:first-child {\n    display: none;\n}\n.table-dark {\n    color: inherit;\n    color: white;\n}\n.table {\n    border-collapse: collapse !important;\n    border-collapse: inherit !important;\n}\n.table td, .table th {\n    background-color: inherit !important;\n}\n#line-chart {\n    max-width: 100%;\n}\n.col-sm-10.offset-sm-1.col-12 p.mb-5 {\n    display: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
